<template>
  <div>
    <!-- 主要内容 begin -->
    <div id="content-main">
      <!-- 操作栏 -->
      <div class="flex-between">
        <div class="flex-start">
          <div class="search-item">
            <a-select
              v-model="category_id"
              placeholder="请选择一级分类"
              :options="categoryOptions"
              :allowClear="true"
              style="width: 200px"
              @change="categorySearchChange"
            ></a-select>
            <a-select
              v-model="subcategory_id"
              placeholder="请选择二级分类"
              :options="subcategoryOptions"
              :allowClear="true"
              style="width: 200px; margin-left: 10px;"
            ></a-select>
            <a-input
              v-model="keyword"
              placeholder="请输入文章名称"
              :allowClear="true"
              style="width: 200px; margin:0 10px"
            />
            <a-button type="primary" icon="search" @click="search">搜索</a-button>
            <a-button type="primary" @click="refresh" style="margin-left:10px">重置</a-button>
          </div>
        </div>
        <a-button type="primary" icon="plus" @click="add">新建</a-button>
      </div>
      <!-- 分割线 -->
      <a-divider />
      <!-- 列表 -->
      <a-table :columns="columns" :data-source="list" :scroll="{ x: 1500 }">
        <template slot="cover" slot-scope="text">
          <a-avatar :src="coverUrl(text.url)" shape="square" :size="64" />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="edit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定删除?"
            @confirm="() => deleteItem(record.id)"
          >
            <a style="color:red">删除</a>
          </a-popconfirm>
        </template>
      </a-table>

      <!-- 分页 -->
      <Pagination :current="current" :pageSize="pageSize" :total="total" />
    </div>
    <!-- 主要内容 end -->

    <!-- 弹出： 新增编辑 -->
    <a-modal
      v-if="visible"
      :title="title"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submit"
      @cancel="cancel"
      :width="1000"
    >
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        v-bind="layout"
      >
        <a-form-model-item has-feedback label="案例集标题" prop="title">
          <a-input v-model="ruleForm.title" :allowClear="true"/>
        </a-form-model-item>
        <a-form-model-item has-feedback label="封面" prop="cover">
          <a-upload
            :file-list="ruleForm.cover"
            name="file"
            action="/api/qiniu/upload"
            list-type="picture"
            @change="uploadChange"
          >
            <a-button
              ><a-icon
                type="cloud-upload"
                style="color:#FFB6B8"
              />选择文件</a-button
            >
          </a-upload>
        </a-form-model-item>
        <a-form-model-item has-feedback label="一级分类" prop="category">
          <a-select
            v-model="ruleForm.category"
            show-search
            placeholder="请选择"
            :allowClear="true"
            :options="categoryOptions"
            @change="categoryFormChange"
          ></a-select>
        </a-form-model-item>
        <a-form-model-item has-feedback label="二级分类" prop="subcategory">
          <a-select
            v-model="ruleForm.subcategory"
            show-search
            placeholder="请选择"
            :allowClear="true"
            :options="subcategoryOptions2"
          ></a-select>
        </a-form-model-item>
        <a-form-model-item has-feedback label="案例时间" prop="caseTime">
          <a-date-picker  @change="caseTimeChange" :default-value="moment(ruleForm.caseTime)" />
        </a-form-model-item>
        <a-form-model-item has-feedback label="浏览量" prop="views">
          <a-input-number v-model="ruleForm.views" />
        </a-form-model-item>
        <a-form-model-item has-feedback label="推荐值" prop="recommend">
          <a-input-number v-model="ruleForm.recommend" />
          *填写后即可推荐到首页，越大越靠前
        </a-form-model-item>
        <a-form-model-item has-feedback label="内容" prop="content">
          <vue-ueditor-wrap
            v-model="ruleForm.content"
            :config="ueditorConfig"
          ></vue-ueditor-wrap>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import Pagination from "../components/Pagination.vue";
import VueUeditorWrap from "vue-ueditor-wrap";
import moment from 'moment';

let ruleFormInit = {
  title: "",
  category: "",
  subcategory: "",
  cover:[],
  caseTime: "",
  views: 1,
  recommend: null,
  content: "",
}

export default {
  components: {
    Pagination,
    VueUeditorWrap
  },
  computed:{
  },
  data() {
    return {
      category_id: undefined,
      subcategory_id: undefined,
      detail: null,
      title: "",
      visible: false,
      confirmLoading: false,
      list: [],
      total: 0,
      // 查询参数
      pageSize: 10,
      current: 1,
      keyword: "",
      columns: [
        {
          title: "封面",
          dataIndex: "cover",
          scopedSlots: { customRender: "cover" },
          width: 200
        },
        {
          title: "案例集标题",
          dataIndex: "title",
          width: 200
        },
        {
          title: "一级分类",
          dataIndex: "category.name",
          width: 200
        },
        {
          title: "二级分类",
          dataIndex: "subcategory.name",
          width: 200
        },
        {
          title: "案例时间",
          dataIndex: "caseTime",
          width: 200
        },
        {
          title: "浏览量",
          dataIndex: "views",
          width: 100
        },
        {
          title: "推荐值",
          dataIndex: "recommend",
          width: 100
        },
        {
          title: "创建时间",
          dataIndex: "createdTime",
          width: 200
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
          width: 200
        },
        {
          title: "操作",
          key: "operation",
          width: 240,
          fixed: 'right',
          scopedSlots: {
            customRender: "operation"
          }
        }
      ],
      ruleForm: ruleFormInit,
      rules: {
        title: [{ required: true, trigger: "blur", message: "必填" }],
        category: [{ required: true, trigger: "change", message: "必选" }],
        subcategory: [{ required: true, trigger: "change", message: "必选" }],
        cover: [{ required: true, trigger: "change", message: "必选" }],
        caseTime: [{ required: true, trigger: "blur", message: "必填" }],
        views: [{ required: true, trigger: "blur", message: "必填" }],
        recommend: [{ required: false, trigger: "blur", message: "必填" }],
        content: [{ required: true, trigger: "blur", message: "必填" }],
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18 }
      },
      categoryOptions: [],
      subcategoryOptions: [],
      subcategoryOptions2: [],
      ueditorConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: true,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: "/api/qiniu/ueditor_upload",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "./static/UEditor/"
      }
    };
  },
  created() {
    this.getList();
    this.api.getCategoryList({}, res => {
      this.categoryOptions = [];
      res.data &&
        res.data.list.forEach(item => {
          this.categoryOptions.push({
            value: item.id,
            label: item.name
          });
        });
    });
  },
  methods: {
    moment,
    coverUrl(url){
      if(url.indexOf('.mp4') > -1){
        return url + '?vframe/jpg/offset/1'
      }else{
        return url
      }
    },
    caseTimeChange(date, dateString){
      console.log(date, dateString)
      this.ruleForm.caseTime = null
      if(dateString){
        this.ruleForm.caseTime = dateString
      }
      this.$refs.ruleForm.validateField('caseTime')
    },
    async categoryFormChange(e){
      console.log(e)
      this.ruleForm.subcategory = null
      this.subcategoryOptions2 = [];
      if(e){
        await this.api.getSubCategoryList({ category_id: e }, res => {
          res.data &&
            res.data.list.forEach(item => {
              this.subcategoryOptions2.push({
                value: item.id,
                label: item.name
              });
            });
        });
      }
    },
    categorySearchChange(e){
      console.log(e)
      this.subcategoryOptions = [];
      if(e){
        this.api.getSubCategoryList({ category_id: e }, res => {
          res.data &&
            res.data.list.forEach(item => {
              this.subcategoryOptions.push({
                value: item.id,
                label: item.name
              });
            });
        });
      }else{
        this.subcategory_id = undefined
      }
    },
    async add() {
      this.title = "新建";
      this.visible = true;
    },
    async edit(item) {
      this.detail = {
        id: item.id,
        title: item.title,
        cover: [
          {
            name: item.cover.name,
            response: {
              data: item.cover
            },
            url: item.cover.url,
            status: "done",
            uid: ""
          }
        ],
        category: item.category.id,
        subcategory: item.subcategory.id,
        caseTime: item.caseTime,
        views: item.views,
        recommend: item.recommend,
        content: item.content,

      };
      await this.categoryFormChange(item.category.id)
      this.ruleForm = this.detail;
      this.title = "编辑";
      this.visible = true;
    },
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = {
            ...this.ruleForm,
            cover: this.ruleForm.cover[0].response.data.id
          };
          if (this.detail) {
            this.api.updateArticle(
              { id: this.detail.id, ...params },
              res => {
                if (res.success) {
                  this.$notification.success({
                    message: "提交成功",
                    description: res.message
                  });
                  this.cancel();
                  this.getList();
                } else {
                  this.$notification.error({
                    message: "错误警告！",
                    description: res.message
                  });
                }
              }
            );
          } else {
            this.api.createArticle(params, res => {
              if (res.success) {
                this.$notification.success({
                  message: "提交成功",
                  description: res.message
                });
                this.cancel();
                this.refresh();
              } else {
                this.$notification.error({
                  message: "错误警告！",
                  description: res.message
                });
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancel() {
      this.detail = null;
      this.ruleForm = ruleFormInit;
      this.subcategoryOptions2 = []
      this.$refs.ruleForm.resetFields();
      this.visible = false;
    },
    uploadChange(info) {
      console.log(info);
      let fileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      fileList = fileList.slice(-1);

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });

      this.ruleForm.cover = fileList;
    },
    // 重置刷新
    refresh() {
      this.pageSize = 10
      this.current = 1
      this.keyword = ""
      this.category_id = undefined
      this.subcategory_id = undefined
      this.subcategoryOptions = []
      this.getList();
    },
    // 查询
    search() {
      this.current = 1;
      this.getList();
    },
    // 列表方法
    getList() {
      this.loading = true;
      let params = {
        limit: this.pageSize,
        current: this.current,
        keyword: this.keyword,
        category_id: this.category_id || null,
        subcategory_id: this.subcategory_id || null
      };
      this.api.getArticleList(params, res => {
        this.loading = false;
        if (res.success) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$notification.error({
            message: "错误警告！",
            description: res.message
          });
        }
      });
    },
    // 分页方法
    handleTableChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },
    deleteItem(id) {
      console.log("delete", id);
      this.api.deleteArticle({ id: id }, res => {
        if (res.success) {
          this.$notification.success({
            message: "删除成功",
            description: res.message
          });
          this.refresh();
        } else {
          this.$notification.error({
            message: "错误警告！",
            description: res.message
          });
        }
      });
    }
  }
};
</script>
